import $ from "jquery";
import sortBy from "lodash.sortby";

import Config from "./Config";
import Util from "./Util";

// ---- CONFIG ---
let allServerUrls = {
    "localhost": "http://localhost:8080/allsvenskan",
    "localhost-allsvenskan": "http://localhost:8080/allsvenskan",
    "localhost-superettan": "http://localhost:8080/superettan",

    "demo-tomas": "https://demo-api.forzify.com/demo-tomas",
    "demo-amedia": "https://demo-api.forzify.com/demo-amedia",
    "demo-shl": "https://demo-api.forzify.com/demo-shl",

    "staging-allsvenskan": "https://staging-api.forzify.com/allsvenskan",
    "staging-superettan" : "https://staging-api.forzify.com/superettan",
    "staging-sef-friendlies": "https://staging-api.forzify.com/sef-friendlies",
    "staging-eliteserien": "https://staging-api.forzify.com/eliteserien",

    "allsvenskan": "https://tagging-api.forzify.com/allsvenskan",
    "superettan" : "https://tagging-api.forzify.com/superettan",
    "sef-friendlies": "https://tagging-api.forzify.com/sef-friendlies",
    "eliteserien": "https://api.forzify.com/eliteserien",
};

export class Server {
    // Variables should be used as read-only - updated only via the class functions
    constructor (name, url) {
        this.name = name;
        this.url = url;
        this.accessToken = "";
        this.username = "";
        this.isAdmin = true;
        this.user = null;
    }

    load (obj) {
        this.accessToken = obj.accessToken;
        this.username = obj.username;
        // Backwards compatibility, we assume existing sessions are valid - otherwise they just get an error later
        this.isAdmin = (obj.isAdmin === null || obj.isAdmin === undefined) ? true : obj.isAdmin;
    }

    toJson () {
        return {
            name: this.name,
            url: this.url,
            accessToken: this.accessToken,
            username: this.username,
            isAdmin: this.isAdmin,
        }
    }

    createUrl (resourceUrl, queryParams) {

        // Already converted
        if (resourceUrl instanceof URL) return resourceUrl;

        if (!resourceUrl.startsWith(this.url)) {
            resourceUrl = this.url + resourceUrl;
        }

        let url = new URL(resourceUrl);

        if (typeof queryParams === "object") {
            Object.keys(queryParams).forEach(key => url.searchParams.append(key, queryParams[key]));
        }

        if (this.accessToken) {
            url.searchParams.append('access_token', this.accessToken);
        }

        return url;
    }

    get (endpoint, successCallback, errorCallback, fetchExtraParams) {
        let fetchInit = {
            method: "GET",
            credentials: "include",
            mode: "cors"
        };
        if (typeof fetchExtraParams === "object") {
            $.extend(fetchInit, fetchExtraParams);
        }
        Util.fetch(this.createUrl(endpoint), successCallback, errorCallback, fetchInit);
    }

    post (endpoint, jsonData, successCallback, errorCallback, fetchExtraParams) {
        let fetchInit = {
            method: "POST",
            credentials: "include",
            mode: "cors",
            headers: {
                "Accept": "*/*",
                "Content-Type": "application/json; charset=UTF-8"
            },
            body: JSON.stringify(jsonData)
        };
        if (typeof fetchExtraParams === "object") {
            $.extend(fetchInit, fetchExtraParams);
        }
        Util.fetch(this.createUrl(endpoint), successCallback, errorCallback, fetchInit);
    }

    put (endpoint, jsonData, successCallback, errorCallback, fetchExtraParams) {
        let fetchInit = {
            method: "PUT",
            credentials: "include",
            mode: "cors",
            headers: {
                "Accept": "*/*",
                "Content-Type": "application/json; charset=UTF-8"
            },
            body: JSON.stringify(jsonData)
        };
        if (typeof fetchExtraParams === "object") {
            $.extend(fetchInit, fetchExtraParams);
        }
        Util.fetch(this.createUrl(endpoint), successCallback, errorCallback, fetchInit);
    }

    delete (endpoint, jsonData, successCallback, errorCallback, fetchExtraParams) {
        let fetchInit = {
            method: "DELETE",
            credentials: "include",
            mode: "cors",
            headers: {
                "Accept": "*/*",
                "Content-Type": "application/json; charset=UTF-8"
            }
        };
        if (jsonData) {
            fetchInit.body = JSON.stringify(jsonData);
        }
        if (typeof fetchExtraParams === "object") {
            $.extend(fetchInit, fetchExtraParams);
        }
        Util.fetch(this.createUrl(endpoint), successCallback, errorCallback, fetchInit);
    }

    logIn (username, accessToken, accessLevel) {
        this.username = username;
        this.accessToken = accessToken;
        this.isAdmin = accessLevel === "admin";

        saveToLocalStorage();
    }

    logOut () {
        this.username = "";
        this.accessToken = "";

        saveToLocalStorage();
    }

}

export function getServer (server) {
    return servers[server];
}

export function listServers () {
    return sortBy(Object.values(servers), "name");
}

export function listLoggedInServers () {
    return listServers().filter((s) => s.accessToken !== "");
}

// ------------------- Private functions -------------

let servers = {};

// Read which servers to use from config. Expecting comma separated string, e.g., "allsvenskan, superettan"
Config.servers.split(",").map((i) => i.trim()).forEach((server) => {
    if (server in allServerUrls) {
        servers[server] = new Server(server, allServerUrls[server]);
    }
});

//Sync servers with existing user data
loadFromLocalstorage();

console.log("Loaded server info", servers);

function loadFromLocalstorage () {
    getLocalStorageData().forEach((server) => {
        if (server.name && server.name in servers) {
            servers[server.name].load(server);
        }
    });
}

function saveToLocalStorage () {
    localStorage.servers = JSON.stringify(Object.values(servers).map((s) => s.toJson()));
}

function getLocalStorageData () {
    try {
        return JSON.parse(localStorage.servers);
    } catch (e) {
        return [];
    }
}




// WEBPACK FOOTER //
// ./src/js/include/Server.js